import { RECEIVE_SUBLIME_NARVAR_APP_CTA } from '../../actions/appCta';

export const initialState = {
  enabled: false,
};

export default (state = initialState, { type, data } = {}) => {
  switch (type) {
    case RECEIVE_SUBLIME_NARVAR_APP_CTA:
      return {
        ...state,
        ...data,
      };

    default:
      return state;
  }
};
